import { DataView24, Edit24 } from "@carbon/icons-react";
import {
  Button,
  ButtonSet,
  Column,
  Form,
  FormGroup,
  Loading,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  basicApplicationSchema,
  companySchema,
} from "../../services/SchemaService";
import SubmitButton from "../../components/Buttons/SubmitButton";
import { toast } from "react-toastify";
import ProvinceCombo from "../../components/Combos/ProvinceCombo";
import DistrictCombo from "../../components/Combos/DistrictCombo";
import { UserAvatar24 } from "@carbon/icons-react";
import DataOperationButton from "../../components/Buttons/DataOperationButton";
import InternshipFillingInstructions from "../../components/Miscellaneous/InternshipFillingInstructions";
import PaginatedDataTable from "../../components/Table/PaginatedDataTable";
import InternshipTermsAndConditions from "../../components/Miscellaneous/InternshipTermsAndConditions";

const tableHeaders = [
  {
    header: "Título",
    key: "vacancyTitle",
  },
  {
    header: "Empresa",
    key: "companyName",
  },

  {
    header: "Visualizar",
    key: "vacancyUuid",
  },
];

const CompetitorDashboardPage = () => {
  const { user, isCompetitor, isWinner } = useContext(AuthContext);
  const [application, setApplication] = useState(null);
  const [businessPlan, setBusinessPlan] = useState(null);
  const [company, setCompany] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [districts, setDistricts] = useState([]);
  const [profile, setProfile] = useState(null);
  const [items, setItems] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(companySchema),
    mode: "onBlur",
  });

  const navigate = useNavigate();

  const loadApplication = async () => {
    try {
      const response = await http.get(`/applications/phone/${user.username}`);
      setApplication(response.data);
    } catch (error) {}
  };

  const loadBusinessPlan = async () => {
    try {
      const response = await http.get(`/business-plan/nur/NUR${user.username}`);
      setBusinessPlan(response.data);
    } catch (error) {}
  };

  const loadCompany = async () => {
    try {
      const response = await http.get(
        `/internships/companies/nur/NUR${user.username}`
      );
      setCompany(response.data);
      reset(response.data);
    } catch (error) {}
  };

  const handlCreate = () => {
    navigate("../registar-candidatura", { replace: true });
  };
  const handlUpdate = () => {
    navigate("../actualizar-candidatura/" + application.uuid, {
      replace: true,
    });
  };

  const onSubmit = async (data) => {
    try {
      const response =
        company == null
          ? await http.post("/internships/companies", data)
          : await http.put("/internships/companies", data);
      toast.success("Empresa actualizada com sucesso");
      loadCompany();
      setDisabled(true);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  const getCellContent = (cell, id) => {
    if (cell.info.header === "vacancyUuid") {
      return (
        <DataOperationButton
          operations={[
            {
              id: id,
              url: `../vagas-para-estagio/${cell.value}`,
              icon: DataView24,
              title: "Consultar",
            },
          ]}
        />
      );
    }

    return cell.value;
  };

  const loadProfile = async () => {
    try {
      const response = await http.get(`/internships/trainees/${user.username}`);
      setProfile(response.data);
    } catch (error) {}
  };

  const getApplications = async () => {
    try {
      const response = await http.get(
        `/internships/trainees/${user.username}/applications`
      );
      setItems(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    loadApplication();
    loadBusinessPlan();
    loadCompany();
    loadProfile();
    getApplications();
  }, []);

  return (
    <Card title={"Olá " + user.firstName + " " + user.lastName}>
      {application ? (
        <div>
          <div className="view-header">
            <div>
              <p>
                <strong>Numero Único de Referência: </strong>
                NUR{application?.phoneNumber1}
              </p>
            </div>
          </div>
          <ButtonSet>
            <Button
              renderIcon={DataView24}
              iconDescription="Consultar"
              onClick={() => navigate("../candidatura/" + application.id)}
            >
              Consultar Candidatura
            </Button>
            {businessPlan &&
              (businessPlan.currentStatusCode === 1 ? (
                <Button
                  renderIcon={DataView24}
                  iconDescription="Editar"
                  onClick={() =>
                    navigate("../editar-plano-de-negocio/" + businessPlan.uuid)
                  }
                >
                  Editar Plano de Negócios
                </Button>
              ) : (
                <Button
                  renderIcon={DataView24}
                  iconDescription="Consultar"
                  onClick={() =>
                    navigate("../plano-de-negocio/" + businessPlan.uuid)
                  }
                >
                  Consultar Plano de Negócio
                </Button>
              ))}
            {application.isQualified && !businessPlan && (
              <Button
                renderIcon={DataView24}
                iconDescription="Consultar"
                onClick={() => navigate("../registar-plano-de-negocio")}
              >
                Registar Plano de Negócio
              </Button>
            )}

            {/* {!isWinner && (
              <>
                <Button
                  renderIcon={UserAvatar24}
                  iconDescription="Meu Perfil"
                  onClick={() => navigate("../perfil-estagiario/")}
                >
                  Meu Perfil de estagiário
                </Button>
                <Button
                  renderIcon={DataView24}
                  iconDescription="Meu Perfil"
                  onClick={() => navigate("../vagas-para-estagio/")}
                >
                  Vagas de estágio
                </Button>
              </>
            )} */}
          </ButtonSet>
          {/* {!isWinner && (
            <>
              <InternshipFillingInstructions />
              <h4 className="mt-2">Minhas Candidaturas</h4>
              <PaginatedDataTable
                headers={tableHeaders}
                items={items}
                paginate={false}
                getCellContent={getCellContent}
              ></PaginatedDataTable>
            </>
          )} */}
          {application?.isWinner && (
            <>
              {" "}
              <Form className="mt-2" onSubmit={handleSubmit(onSubmit)}>
                <FormGroup
                  legendText="A.	Identificação da Entidade"
                  className="section-header"
                >
                  <fieldset className="bx--fieldset">
                    <Row>
                      <Column
                        xml={12}
                        sm={3}
                        md={3}
                        lg={3}
                        className="required"
                      >
                        <TextInput
                          labelText="A1. NUR"
                          id="nur"
                          maxLength={64}
                          // disabled={disabled}
                          readOnly={true}
                          value={"NUR" + application?.phoneNumber1}
                          {...register("nur")}
                        />
                        <p className="field-error">{errors.nur?.message}</p>
                      </Column>
                      <Column
                        xml={12}
                        sm={6}
                        md={6}
                        lg={6}
                        className="required"
                      >
                        <TextInput
                          labelText="A2. Designação do Negócio"
                          id="name"
                          maxLength={128}
                          disabled={disabled}
                          {...register("name")}
                        />
                        <p className="field-error">{errors.name?.message}</p>
                      </Column>
                      <Column
                        xml={12}
                        sm={3}
                        md={3}
                        lg={3}
                        className="required"
                      >
                        <TextInput
                          labelText="A3. NUIT"
                          id="nuit"
                          maxLength={9}
                          disabled={disabled}
                          {...register("nuit")}
                        />
                        <p className="field-error">{errors.nuit?.message}</p>
                      </Column>
                    </Row>
                    <Row>
                      <Column sm={12} md={12} lg={12} className="required">
                        <TextArea
                          id="description"
                          labelText="A3. Descrição"
                          helperText="[Descreva de forma resumida a sua empresa, o ramo de negócio e as principais actividades que realiza/Produtos que oferece]"
                          rows={3}
                          enableCounter
                          disabled={disabled}
                          {...register("description")}
                        />
                        <p className="field-error">
                          {errors.description?.message}
                        </p>
                      </Column>
                    </Row>
                  </fieldset>
                </FormGroup>
                <FormGroup
                  legendText="B.	Localização da Entidade"
                  className="section-header"
                >
                  <fieldset className="bx--fieldset">
                    <Row>
                      <Column
                        xml={12}
                        sm={6}
                        md={3}
                        lg={3}
                        className="required"
                      >
                        <ProvinceCombo
                          id="provinceId"
                          name="provinceId"
                          label="B1. Província"
                          disabled={disabled}
                          control={control}
                          setDistricts={setDistricts}
                        />
                        <p className="field-error">
                          {errors.provinceId?.message}
                        </p>
                      </Column>

                      <Column
                        xml={12}
                        sm={6}
                        md={3}
                        lg={3}
                        className="required"
                      >
                        <DistrictCombo
                          id="districtId"
                          name="districtId"
                          label="B2. Distrito"
                          disabled={disabled}
                          items={districts}
                          control={control}
                        />
                        <p className="field-error">
                          {errors.districtId?.message}
                        </p>
                      </Column>
                      <Column
                        xml={12}
                        sm={6}
                        md={6}
                        lg={6}
                        className="required"
                      >
                        <TextInput
                          labelText="B3. Endereço Físico (Rua/Av., Número do Edifício, Quarteirão e Bairro)"
                          id="address"
                          maxLength={128}
                          disabled={disabled}
                          {...register("address")}
                        />
                        <p className="field-error">{errors.address?.message}</p>
                      </Column>
                    </Row>
                  </fieldset>
                </FormGroup>
                <FormGroup
                  legendText="C.	Dados de Registo da Entidade "
                  className="section-header"
                >
                  <fieldset className="bx--fieldset">
                    <Row>
                      <Column
                        xml={12}
                        sm={6}
                        md={4}
                        lg={4}
                        className="required"
                      >
                        <TextInput
                          labelText="C1. Número do Alvará"
                          id="permitNumber"
                          maxLength={128}
                          disabled={disabled}
                          {...register("permitNumber")}
                        />
                        <p className="field-error">
                          {errors.permitNumber?.message}
                        </p>
                      </Column>

                      <Column
                        xml={12}
                        sm={6}
                        md={4}
                        lg={4}
                        className="required"
                      >
                        <TextInput
                          labelText="C2 Certidão Comercial [Indicar o código ou NUEL]"
                          id="commercialCertificate"
                          maxLength={128}
                          disabled={disabled}
                          {...register("commercialCertificate")}
                        />
                        <p className="field-error">
                          {errors.commercialCertificate?.message}
                        </p>
                      </Column>
                      <Column xml={12} sm={6} md={4} lg={4}>
                        <TextInput
                          labelText="C3. Licença Simplificada [Indicar o código]"
                          id="simplifiedLicense"
                          maxLength={128}
                          disabled={disabled}
                          {...register("simplifiedLicense")}
                        />
                        <p className="field-error">
                          {errors.simplifiedLicense?.message}
                        </p>
                      </Column>
                    </Row>
                    <Row>
                      <Column
                        xml={12}
                        sm={6}
                        md={4}
                        lg={4}
                        className="required"
                      >
                        <TextInput
                          labelText="C4. Tipo de Entidade Legal"
                          id="legalEntityType"
                          maxLength={128}
                          disabled={disabled}
                          {...register("legalEntityType")}
                        />
                        <p className="field-error">
                          {errors.legalEntityType?.message}
                        </p>
                      </Column>

                      <Column
                        xml={12}
                        sm={6}
                        md={4}
                        lg={4}
                        className="required"
                      >
                        <TextInput
                          labelText="C5. Sector de Actividade"
                          id="sectorOfActivity"
                          maxLength={128}
                          disabled={disabled}
                          {...register("sectorOfActivity")}
                        />
                        <p className="field-error">
                          {errors.sectorOfActivity?.message}
                        </p>
                      </Column>
                      <Column
                        xml={12}
                        sm={6}
                        md={4}
                        lg={4}
                        className="required"
                      >
                        <TextInput
                          placeholder="dd/mm/aaaa"
                          labelText="C6. Data do Início de Actividades"
                          id="startDateOfActivities"
                          disabled={disabled}
                          {...register("startDateOfActivities")}
                        />
                        <p className="field-error">
                          {errors.startDateOfActivities?.message}
                        </p>
                      </Column>
                    </Row>
                  </fieldset>
                </FormGroup>
                <Row>
                  <Column sm={12} md={12} lg={12} className="form-buttons">
                    <ButtonSet>
                      {disabled && (
                        <Button
                          type="button"
                          onClick={() => {
                            setDisabled(false);
                          }}
                        >
                          Editar
                        </Button>
                      )}

                      {!disabled && (
                        <>
                          <SubmitButton />
                          <Button
                            type="button"
                            kind="secondary"
                            onClick={() => {
                              setDisabled(true);
                            }}
                          >
                            Cancelar
                          </Button>
                        </>
                      )}
                    </ButtonSet>
                  </Column>
                </Row>
              </Form>
              <div className="mt-2">
                <InternshipTermsAndConditions />
              </div>
              {/* <h4 className="mt-2">Critérios de avaliação de candidaturas</h4>
              <p>
                As candidaturas a estágio devem ser avaliadas/pontuadas
                obedecendo aos seguintes aspectos e ponderadores:
              </p>
              <div>
                <p>
                  1. O candidato tem a formação técnica mínima exigida para
                  desempenhar com sucesso as tarefas na Vaga a que se candidata;
                  (25%)
                </p>
                <p>
                  2. O candidato possui qualificações técnicas adicionais
                  relevante para a vaga/posição a que se candidata? (20%)
                </p>
                <p>
                  3. O candidato possui a experiência profissional relacionada
                  com área/posição a que se candidata (25%)
                </p>
                <p>
                  4. O candidato possui proficiência nos idiomas necessários
                  para desempenhar com sucesso as actividades na vaga/posição a
                  que se candidata? (15%)
                </p>
                <p>
                  5. O candidato possui as habilidades sociais, comportamentais
                  e atitudes necessárias para desempenhar com sucesso as
                  actividades na vaga/posição a que se candidata? (15%)
                </p>
              </div> */}
            </>
          )}
        </div>
      ) : (
        <div>
          {/* <h5>Regista a tua candidatura até ao dia 30/01/2023</h5>
          <p className="mt-1">
            - Clica no botão Registar Candidatura para abrires o formulário de
            candidatura
          </p>
          <p>
            - Podes registar a candidatura em partes, salvando no fim de cada
            actualização
          </p>
          <p>
            - Quando estiveres satisfeito com o registo, submeta. Mas atenção,
            uma vez submetida, a candidatura não pode ser alterada
          </p> */}
          {/* <Button className="mt-2" onClick={handlCreate}>
            Registar a Candidatura
          </Button> */}
        </div>
      )}
      <div className="mt-2">
        {/* <h5>Regista o teu plano de negócio até ao dia 20/10/2023</h5>
        <p className="mt-1">
          - Clica em <strong>Registar/Editar Plano de Negócio</strong> para
          abrires o formulário.
        </p>
        <p>
          - Podes registar o plano de negócio em partes, salvando no fim de cada
          actualização.
        </p>
        <p>
          - Quando estiveres satisfeito com o registo, submeta. Mas atenção, uma
          vez submetida, o plano de negócio não pode ser alterado.
        </p> */}
        {/* <Button className="mt-2" onClick={handlCreate}>
            Registar a Candidatura
          </Button> */}
      </div>
    </Card>
  );
};

export default CompetitorDashboardPage;
